import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper'; // modules
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import scannerImage from "../../images/technology/scanner.gif"
import printerImage from "../../images/technology/3dprinter.gif"
import millImage from "../../images/technology/mill.gif"
import { useRef } from 'react';
const technologyInfo = [
    {
        imgSrc: millImage,
        description: "Experience precision and consistent results with our 5-axis zirconia mill, now with a guaranteed 3-day crown turnaround.",
        imgDescription:"zirconia_mill_machine"
    }, 
    {
        imgSrc: scannerImage,
        description: "Along with digital X-rays that instantly capture and display images on a computer screen, we also use an intraoral camera to take real-life photos of your teeth—making it easier to explain treatment recommendations. Recently, we’ve added an advanced intraoral scanner that creates highly accurate digital impressions. These scans can be sent directly to the lab for creating crowns, retainers, bridges, and implant restorations.",
        imgDescription:"scanner_machine"
    },
    {
        imgSrc: printerImage,
        description: "Our state-of-the-art 3D printer brings digital smile designs to life, creating precise physical mock-ups that let patients see, touch, and experience their new smile before starting treatment",
        imgDescription:"3dprinter_machine"
    }, 
]
export const TechnologySection = (props) => {
  const swiperRef = useRef();
  return (
    <section id="technology-section" className={`wpo-hero-section section-padding ${props.class}`}>
      {/* scanner */}
      <div className="container">
         {/* <Swiper
            // install Swiper modules
            modules={[Navigation, Pagination]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
          > */}
          <Swiper
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            // onSwiper={(swiper) => console.log(swiper)}
      >
          {technologyInfo.map((info,idx)=> (
            <SwiperSlide key={idx}>
                <OneTechnologySection description={info.description} imgSrc={info.imgSrc} imgDescription={idx}/>
            </SwiperSlide>
          ))}
        
        
       </Swiper>
       <div className='mt-4 d-flex justify-content-center gap-2'>
          <button className="btn btn-outline-secondary" onClick={() => swiperRef.current?.slidePrev()}>Prev</button>
          <button className="btn btn-outline-secondary" onClick={() => swiperRef.current?.slideNext()}>Next</button>
       </div>
      </div>
    </section>
    
  )
}
const  OneTechnologySection = ({description, imgSrc, imgDescription}) => {
    return (
      <div className="row " style={{ justifyContent: "space-between" }}>
        <div className="col-lg-5 col-md-12 col-12" >
            <div className="wpo-section-title">
              <span>Technology</span>
              <h1>Our Cool Technologies</h1>
            </div>
            
            <div>
              <p >
                {description}
              </p>
            </div>
          
        </div>

        {/* PIC ON THE RIGHT */}
        <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center">
          <img src={imgSrc} alt={imgDescription} className="img-fluid" />
        </div>
      </div>
  );
}
